
























import { createComponent, ref } from "@vue/composition-api";
import { useActions } from "@/shared/useMegaraxClient";
import { Autocomplete } from "element-ui";
import SiteSearchBarSuggestion from "./SiteSearchBarSuggestion.vue";
import { searchSuggestionResource } from "@megarax/client/src/resources/search/SearchSuggestion";
import { getResourceModulePath, getModulePath } from "../apps/getPath";
import { searchResultModule } from "../apps/search/searchResult/module";
import { searchResultResource } from "@megarax/client/src/resources/search/SearchResult";

interface Props {}

export default createComponent<Props>({
  components: { SiteSearchBarSuggestion },
  props: {},
  setup(props, ctx) {
    const searchText = ref("");

    const searchSuggestionActions = useActions(searchResultResource);

    const fetchSuggestions: Autocomplete["fetchSuggestions"] = (
      term,
      callback,
    ) => {
      searchSuggestionActions
        .search({
          searchTerm: term,
        })
        .then((response) => callback(response.items));
    };

    function onSelect(value: any) {
      if (typeof value.value == "string") {
        goToFullSearch();
        return;
      }

      ctx.root.$router.push(
        getResourceModulePath(
          { appLabel: value.app, name: value.resource },
          value.id,
        )!,
      );
      searchText.value = "";
    }

    function goToFullSearch() {
      if (!searchText.value) return;

      ctx.root.$router.push(
        getModulePath(searchResultModule, searchText.value),
      );
      searchText.value = "";
    }

    return { searchText, fetchSuggestions, onSelect, goToFullSearch };
  },
});
